// vendor
import { computed, ref, Ref, ComputedRef } from "@vue/composition-api";
// project
import { useAssets } from "@/hooks/useAssets";
import { useListSort } from "@/hooks/useListSort";

export const useRecentAssets = (days:Ref<number>|ComputedRef<number>) => {

	const {
		assets:allAssets
	} = useAssets();

	const asc = ref(false);

	const recentAssets = computed(() => {
		return allAssets.value.filter(a => {
			return (new Date(a.lastModified).getTime()) > peekDate.value;
		});
	});

	const {
		sorted:assets
	} = useListSort(recentAssets, asc, a => (new Date(a.lastModified)).getTime());

	const peekDate = computed(() => Date.now() - (days.value * 24 * 60 * 60 * 1000));

	return {
		assets,
	};
};